export default "__VITE_ASSET__pi497JMS__"